
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

  @Component({
    components: {
    }
  })
  export default class General extends Vue  {
    dialog = false
    editDateMenu = false
    headers = [
      {
        text: 'Name',
        align: 'start',
        value: 'name',
      },
      { text: 'File Name', value: 'originalDocName' },
      { text: 'Date', value: 'date' },
      { text: 'Description', value: 'description' },
      //{ text: 'URL', value: 'url' },
      { text: 'Actions', value: 'actions', sortable: false },
    ]
    items: Array<object> = []
    editedIndex = -1
    editedItem: any = {
      id: null,
      name: '',
      date: '',
      description: '',
      url: '',
      pdf: null,
      bridgeId: -1
    }
    defaultItem: any = {
      id: null,
      name: '',
      date: '',
      description: '',
      url: '',
      pdf: null,
      bridgeId: -1
    }

    @Prop() readonly id!: object
    @Prop() readonly tab!: number

    //Methods
    public editItem(item: object ): void {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    }

    public close(): void {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    }

    public deleteItem(item: object): void {
      confirm('Are you sure you want to delete this item?') && this.$store.dispatch('bridge/deleteBridgeDocument', item)
    }

    public download(item: object): void {
      this.$store.dispatch('bridge/downloadBridgeDocument', item)
    }

    public viewPDF(item: object): void {
      this.$store.dispatch('bridge/openBridgeDocumentPDF', item)
    }

    public save(): void {
      this.editedItem.bridgeId = this.id
      if (this.editedIndex > -1) {
        this.$store.dispatch('bridge/updateBridgeDocument', this.editedItem)
        //Object.assign(this.items[this.editedIndex], this.editedItem)
      } else {
        this.$store.dispatch('bridge/storeBridgeDocument', this.editedItem)
        //this.items.push(this.editedItem)
      }
      this.close()
    }

    //Getters
    get getBridgeDocuments(): any {
      return this.$store.getters['bridge/getBridgeDocuments']
    }
    get getBridgeDocumentPDFLoaded(): any {
      return this.$store.getters['bridge/getBridgeDocumentPDFLoaded']
    }
    get getReload(): boolean {
      return this.$store.getters['bridge/getReload']
    }
    get getLoading(): boolean {
      return this.$store.getters['bridge/getLoading']
    }
    get getMessage(): string {
      return this.$store.getters['bridge/getMsg']
    }
    get getErrors(): Array<string> {
      return this.$store.getters['bridge/getErrors']
    }
    get getDeletePermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }
    get getEditPermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Editor') ||
              this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }

    //Watchers
    @Watch('getReload')
    reload(val: boolean) {
      if(val && this.tab == 4) {
        this.$store.dispatch('bridge/getBridgeDocuments', { id: this.id })
        this.$store.commit('bridge/setReload', false)
      }
    }
    @Watch('getBridgeDocuments')
    setItems(val: any) {
      this.items = val
    }
  }



